import React from 'react';

const PRESS_IMAGE =
  "https://santaplaya-bucket.s3.amazonaws.com/Yona's Fish.webp";

const PressSection: React.FC = () => {
  return (
    <section className="flex flex-col md:flex-row w-full space-x-2 max-h-[50vh] max-w-6xl">
      {/* LEFT COLUMN: Image */}
      <div className="w-full md:w-1/2 h-64 md:h-auto overflow-hidden">
        <img
          src={PRESS_IMAGE}
          alt="Press Feature"
          className="w-full h-full object-contain object-[25%_50%]"
        />
      </div>

      {/* RIGHT COLUMN: Maroon Background & Text */}
      <div
        className="
          w-full 
          md:w-1/2 
          bg-maroon
          flex 
          flex-col 
          justify-center 
          items-center 
          text-center
          px-8
          py-12 
        "
      >
        <p
          className="
            font-prosto 
            text-white
            text-base 
            md:text-lg 
            xl:text-xl 
            leading-relaxed 
            max-w-lg 
            mb-4
          "
        >
          During the worst of the COVID-19 pandemic, Jonathan ‘Yona’ Estrada
          built Yona Redz, one of Santa Barbara’s most popular restaurants. Now,
          he’s bringing the vibrant seafood flavors of Baja California to State
          Street with Santa Playa Mariscos.
        </p>
        <a
          href="https://www.noozhawk.com/bizhawk-restaurateur-dishes-about-plan-for-santa-playa-mariscos-on-state-street/"
          target="_blank"
          rel="noopener noreferrer"
          className="
            font-prosto
            underline
            text-white
            text-base 
            md:text-lg 
            hover:opacity-80
          "
        >
          Read Full Article
        </a>
      </div>
    </section>
  );
};

export default PressSection;
